module.exports = __webpack_public_path__ + "static/media/blog2_web.eb0f3193.webp";